module.exports = __webpack_public_path__ + "static/pA4-fca96c13e8db23d853393142ec96e9b9.png";